var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ls-filter"},[_c('div',{ref:"box",staticClass:"filter"},[_c('el-input',{style:({ width: _vm.width }),attrs:{"placeholder":_vm.kw},model:{value:(_vm.add.kw),callback:function ($$v) {_vm.$set(_vm.add, "kw", $$v)},expression:"add.kw"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }